import { motion } from 'framer-motion';

export default function GearIcon() {
  // Create 24 teeth to match reference image
  const numberOfTeeth = 24;
  const angles = Array.from({ length: numberOfTeeth }, (_, i) => (i * 360) / numberOfTeeth);
  
  // SVG path for a single gear tooth with inner cuts
  const createToothPath = (angle: number) => {
    const innerRadius = 30;
    const outerRadius = 40;
    const toothWidth = 2 * Math.PI * innerRadius / numberOfTeeth * 0.5;
    
    const startAngle = angle - (toothWidth / innerRadius);
    const endAngle = angle + (toothWidth / innerRadius);
    
    const x1 = Math.cos(startAngle * Math.PI / 180) * innerRadius;
    const y1 = Math.sin(startAngle * Math.PI / 180) * innerRadius;
    const x2 = Math.cos(endAngle * Math.PI / 180) * innerRadius;
    const y2 = Math.sin(endAngle * Math.PI / 180) * innerRadius;
    const x3 = Math.cos(endAngle * Math.PI / 180) * outerRadius;
    const y3 = Math.sin(endAngle * Math.PI / 180) * outerRadius;
    const x4 = Math.cos(startAngle * Math.PI / 180) * outerRadius;
    const y4 = Math.sin(startAngle * Math.PI / 180) * outerRadius;
    
    return `M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z`;
  };

  return (
    <motion.svg
      viewBox="0 0 200 200"
      className="absolute inset-0 w-full h-full"
      initial={{ rotate: 0 }}
      animate={{ rotate: 360 }}
      transition={{
        duration: 20,
        repeat: Infinity,
        ease: "linear"
      }}
    >
      <defs>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      <g transform="translate(100 100)">
        {/* Gear teeth */}
        {angles.map((angle, i) => (
          <path
            key={`tooth-${i}`}
            d={createToothPath(angle)}
            fill="#3B82F6"
            stroke="#3B82F6"
            strokeWidth="1"
            filter="url(#glow)"
          />
        ))}

        {/* Main gear circle */}
        <circle
          r="30"
          fill="none"
          stroke="#3B82F6"
          strokeWidth="2"
          filter="url(#glow)"
        />

        {/* Inner spokes */}
        {Array.from({ length: 6 }).map((_, i) => {
          const angle = (i * 60);
          return (
            <path
              key={`spoke-${i}`}
              d={`M ${Math.cos((angle * Math.PI) / 180) * 12} ${Math.sin((angle * Math.PI) / 180) * 12} 
                 L ${Math.cos((angle * Math.PI) / 180) * 28} ${Math.sin((angle * Math.PI) / 180) * 28}`}
              stroke="#3B82F6"
              strokeWidth="4"
              filter="url(#glow)"
            />
          );
        })}

        {/* Inner circles */}
        <circle r="20" fill="none" stroke="#3B82F6" strokeWidth="2" />
        <circle r="12" fill="none" stroke="#3B82F6" strokeWidth="2" />

        {/* Center ring with base */}
        <circle r="6" fill="none" stroke="#3B82F6" strokeWidth="2" />
        <rect x="-2" y="6" width="4" height="6" fill="#3B82F6" filter="url(#glow)" />
      </g>
    </motion.svg>
  );
}